export default __webpack_public_path__ + "static/logoHomeUniversoCole-4623cef7a55055adb226e2719951fb93.png";